<div class="totals-display">
  <p-card [header]="showTitle ? 'Order Totals' : undefined">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state text-center py-4">
      <i class="pi pi-spin pi-spinner text-2xl text-gray-400"></i>
      <div class="text-xs text-gray-500 mt-1">Calculating...</div>
    </div>

    <!-- No Totals State -->
    <div
      *ngIf="!isLoading && !hasTotals()"
      class="empty-state text-center py-4"
    >
      <i class="pi pi-calculator text-2xl text-gray-400"></i>
      <div class="text-xs text-gray-500 mt-1">Add items to see totals</div>
    </div>

    <!-- Totals Breakdown (matches old QMC structure exactly) -->
    <div *ngIf="!isLoading && hasTotals()" class="totals-breakdown">
      <!-- 1. Order item subtotal -->
      <div class="totals-row">
        <span class="label">Order item subtotal</span>
        <span class="value">${{ getItemsSubtotal().toFixed(2) }}</span>
      </div>

      <!-- 2. Order item price discount (if any) -->
      <div *ngIf="getItemsDiscount() > 0" class="totals-row discount">
        <span class="label">Order item price discount</span>
        <span class="value text-green-600"
          >-${{ getItemsDiscount().toFixed(2) }}</span
        >
      </div>

      <!-- 3. Order coupon discounts (item coupons only) -->
      <div
        *ngFor="let coupon of getItemCoupons()"
        class="totals-row discount coupon-item"
      >
        <span class="label">
          <i class="pi pi-ticket mr-1 text-xs"></i>
          Order coupon discount (Coupon: {{ coupon.Description }})
        </span>
        <span class="value text-green-600"
          >-${{ Math.abs(coupon.Amount).toFixed(2) }}</span
        >
      </div>

      <!-- 4. Order subtotal -->
      <div class="totals-row subtotal">
        <span class="label">Order subtotal</span>
        <span class="value">${{ getSubtotal().toFixed(2) }}</span>
      </div>

      <p-divider />

      <!-- 5. Shipping rate description and amount -->
      <div class="totals-row">
        <span class="label">{{ getShippingDescription() }}</span>
        <span class="value">${{ getShippingSubtotal().toFixed(2) }}</span>
      </div>

      <!-- 6. Shipping coupon discounts -->
      <div
        *ngFor="let coupon of getShippingCoupons()"
        class="totals-row discount coupon-item"
      >
        <span class="label">
          <i class="pi pi-ticket mr-1 text-xs"></i>
          Shipping coupon discount (Coupon: {{ coupon.Description }})
        </span>
        <span class="value text-green-600"
          >{{ coupon.Amount > 0 ? "-" : "+" }}${{
            Math.abs(coupon.Amount).toFixed(2)
          }}</span
        >
      </div>

      <!-- 7. Shipping total (CRITICAL: was missing) -->
      <div class="totals-row">
        <span class="label">Shipping total</span>
        <span class="value">${{ getShippingTotal().toFixed(2) }}</span>
      </div>

      <p-divider />

      <!-- 8. Individual tax lines -->
      <div *ngFor="let tax of getIndividualTaxes()" class="totals-row">
        <span class="label">{{ tax.Description }}</span>
        <span class="value">${{ tax.Amount.toFixed(2) }}</span>
      </div>

      <!-- 9. Tax total -->
      <div class="totals-row">
        <span class="label">Tax total</span>
        <span class="value">{{
          getTotalTax() > 0 ? "$" + getTotalTax().toFixed(2) : "-"
        }}</span>
      </div>

      <p-divider />

      <!-- 10. Grand Total -->
      <div class="totals-row grand-total">
        <span class="label font-semibold">Order total</span>
        <span class="value font-semibold"
          >${{ getGrandTotal().toFixed(2) }}</span
        >
      </div>

      <!-- Savings Summary (if any) -->
      <div
        *ngIf="getTotalCouponDiscount() > 0 || getItemsDiscount() > 0"
        class="savings-summary"
      >
        <i class="pi pi-check-circle text-green-600"></i>
        <span class="text-sm text-green-600 ml-2">
          Customer is saving ${{
            (getTotalCouponDiscount() + getItemsDiscount()).toFixed(2)
          }}
          on this order!
        </span>
      </div>
    </div>
  </p-card>
</div>
